import { useEffect, useState } from 'react';

// Lands here after Microsoft Entra sign-in: the backend redirects to
// /auth/callback?token=… on success or ?error=… on failure. We persist the
// token and hard-navigate to the app root so App bootstraps the session.
const TOKEN_KEY = 'sf-token';

export function AuthCallback() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const error = params.get('error');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      window.location.replace('/');
    } else {
      setDone(true);
    }
  }, [token]);

  if (token && !done) {
    return (
      <div className="grid min-h-screen place-items-center text-muted-foreground">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse-soft" />
          Signing you in…
        </div>
      </div>
    );
  }

  return (
    <div className="grid min-h-screen place-items-center px-5 bg-background">
      <div className="card max-w-sm w-full p-7 text-center animate-rise">
        <h1 className="text-lg font-bold text-foreground">Sign-in failed</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {error ?? 'We could not complete your Microsoft sign-in.'}
        </p>
        <a
          href="/"
          className="mt-5 inline-flex h-10 px-4 items-center justify-center rounded-md bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90"
        >
          Back to sign in
        </a>
      </div>
    </div>
  );
}
